export default __webpack_public_path__ + "static/media/childClothes.851d2a06.svg";